/* eslint-disable prefer-destructuring */
import { BREAKPOINTS_PX } from '../../theme/foundations/breakpoints';

export const IMAGE_PREFIX_TO_REPLACE = '/webimage-';

export const IMAGE_PREFIX_60_x_60 = '/72_dpi_webp_mini-';
export const IMAGE_PREFIX_200_x_200 = '/72_dpi_webp_small-';
export const IMAGE_PREFIX_500_x_500 = '/72_dpi_webp_medium-';
export const IMAGE_PREFIX_1500_x_1500 = '/72_dpi_webp-';

export const IMAGE_PREFIX_BY_WIDTH: Record<number, string> = {
    60: IMAGE_PREFIX_60_x_60,
    100: IMAGE_PREFIX_200_x_200,
    500: IMAGE_PREFIX_500_x_500,
};

const mediaXs = `(max-width: ${BREAKPOINTS_PX.sm - 1}px)`;

interface SourceProps {
    src: string;
    media: string;
}

interface SourcePropsBySize {
    defaultSrc: string;
    sourcesProp?: SourceProps;
}

export const getSourcePropsByWidth = (
    src: string,
    originalWidth?: string | number,
): SourcePropsBySize => {
    if (originalWidth) {
        let width = 9999;

        try {
            width = typeof originalWidth === 'string' ? parseFloat(originalWidth) : originalWidth;
        } catch (e) {
            // Ignore
        }

        let prefix;
        if (width <= 60) {
            prefix = IMAGE_PREFIX_BY_WIDTH[60];
        } else if (width <= 100) {
            prefix = IMAGE_PREFIX_BY_WIDTH[100];
        } else if (width <= 500) {
            prefix = IMAGE_PREFIX_BY_WIDTH[500];
        }

        if (prefix) {
            return {
                defaultSrc: src.replace(IMAGE_PREFIX_TO_REPLACE, prefix),
            };
        }
    }

    return {
        defaultSrc: src.replace(IMAGE_PREFIX_TO_REPLACE, IMAGE_PREFIX_1500_x_1500),
        sourcesProp: {
            src: src.replace(IMAGE_PREFIX_TO_REPLACE, IMAGE_PREFIX_500_x_500),
            media: mediaXs,
        },
    };
};
